<template>
  <div class="page-inner">
    <div class="page-content">
      <slot />
    </div>
    <slot name="fixed" />
  </div>
</template>